
import {
  put,
  select,
  apply,
  call,
} from 'redux-saga/effects';
import {
  getClientAlias,
  getLanguage,
  getQueryFeed,
} from 'reducers';
import { MatchTimelineRequest } from 'fishnet-api';
import { updateMatchTimelineFailed, updateMatchTimeline } from 'actions/fishnet';
import { pollTillResponse } from '../utilLCR';

function* loadTimeline(matchId) {
  const clientAlias = yield select(getClientAlias);
  const language = yield select(getLanguage);
  const qFeed = yield select(getQueryFeed);

  const request = new MatchTimelineRequest(matchId, clientAlias, language, qFeed);
  const response = yield apply(request, request.get);

  if (response && !response.error) {
    yield put(updateMatchTimeline(response, matchId));
  } else if (response && response.error) {
    yield put(updateMatchTimelineFailed(response, matchId));
    throw response;
  } else {
    throw new Error('Update timeline failed');
  }
}

// request once
function* pollTimeline(matchId) {
  yield call(pollTillResponse, {}, loadTimeline, matchId); // poll this endpoint once
}

export default pollTimeline;
